import { Injectable } from '@angular/core';
// import { AppConfiguration } from '@symphony-solo/shared/app-configuration/src';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
// import { RequestFavouriteItemParams } from '../models';


@Injectable()
export class FavouriteItemService {
  constructor(
    private httpService: HttpService,
    ) {}

    public getAccountFavouriteItem(body: any): Observable<any> {
      return this.httpService.makePost<any, any>("getaccountFavouriteItem",  body);
    }
}
